class InteractiveHoverSlider extends HTMLElement {
  constructor() {
    super();
    this.triggers = this.querySelectorAll('.ihs-trigger-item');
    this.contents = this.querySelectorAll('.ihs-content-item');
    this.slides = this.querySelectorAll('.ihs-slide');
    
    this.autoPlayInterval = null;
    this.enableAutoplay = this.dataset.autoplayEnabled === 'true';
    this.autoPlayDuration = parseInt(this.dataset.autoplayDuration) * 1000 || 5000;

    this.init();
  }

  init() {
    this.triggers.forEach((trigger) => {
      const index = parseInt(trigger.dataset.index);

      // Hover interaction (Desktop)
      trigger.addEventListener('mouseenter', () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          this.activateItem(index);
          this.pauseAutoplay();
        }
      });

      // Click interaction (Mobile/All)
      trigger.addEventListener('click', () => {
        this.activateItem(index);
        this.pauseAutoplay();
      });

      trigger.addEventListener('mouseleave', () => {
        if (this.enableAutoplay) this.startAutoplay();
      });
    });

    if (this.enableAutoplay) {
      this.startAutoplay();
      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }

    // Initialize container height for absolute positioned items
    // Wait for fonts/layout or just set it based on tallest item initially?
    // A simple ResizeObserver is best to adjust the container height to the active item or max height.
    this.updateContentHeight();
    window.addEventListener('resize', () => this.updateContentHeight());
  }

  activateItem(index) {
    // 1. Triggers
    this.triggers.forEach(el => el.classList.remove('active'));
    if (this.triggers[index]) this.triggers[index].classList.add('active');

    // 2. Content (Text)
    this.contents.forEach(el => el.classList.remove('active'));
    if (this.contents[index]) this.contents[index].classList.add('active');

    // 3. Slides (Images)
    this.slides.forEach(el => el.classList.remove('active'));
    if (this.slides[index]) this.slides[index].classList.add('active');
  }

  updateContentHeight() {
    // To handle the "Fixed Position" absolute overlap, we need the parent (.ihs-contents)
    // to have the height of the TALLEST content item to prevent overlap with anything below (if any),
    // or at least height of ACTIVE item?
    // User wants "Fixed" so the container shouldn't shrink/grow rapidly.
    // Let's find the max height of all content items and set the container to that.
    
    const contentContainer = this.querySelector('.ihs-contents');
    if (!contentContainer) return;

    let maxHeight = 0;
    this.contents.forEach(item => {
      // Temporarily make visible to measure
      const originalDisplay = item.style.display;
      const originalVisibility = item.style.visibility;
      
      item.style.display = 'block';
      item.style.visibility = 'hidden';
      item.style.position = 'absolute'; // Ensure it's absolute as per CSS
      
      const height = item.offsetHeight;
      if (height > maxHeight) maxHeight = height;
      
      // Revert
      item.style.display = originalDisplay;
      item.style.visibility = originalVisibility;
    });

    if (maxHeight > 0) {
      contentContainer.style.minHeight = `${maxHeight}px`;
    }
  }

  startAutoplay() {
    if (!this.enableAutoplay) return;
    this.pauseAutoplay();
    
    this.autoPlayInterval = setInterval(() => {
      const activeTrigger = this.querySelector('.ihs-trigger-item.active');
      let currentIndex = activeTrigger ? parseInt(activeTrigger.dataset.index) : 0;
      let nextIndex = (currentIndex + 1) % this.triggers.length;
      this.activateItem(nextIndex);
    }, this.autoPlayDuration);
  }

  pauseAutoplay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }
}

customElements.define('interactive-hover-slider', InteractiveHoverSlider);